"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * PNS Client API
 * PNS - Push Notification Service: Api per l\'invio di notifiche
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceSubscriptionApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class DeviceSubscriptionApi extends runtime.BaseAPI {
    /**
     * Rimuove la subscription effettuata da un utente su un device
     * Restituisce lo stato delle subscription per l\'utente
     */
    deviceSubscriptionDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
                throw new runtime.RequiredError('deviceId', 'Required parameter requestParameters.deviceId was null or undefined when calling deviceSubscriptionDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/private/subscription/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Rimuove la subscription effettuata da un utente su un device
     * Restituisce lo stato delle subscription per l\'utente
     */
    deviceSubscriptionDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deviceSubscriptionDeleteRaw(requestParameters);
        });
    }
    /**
     * Restituisce i dati associati alla subscription di un device
     * Restituisce i dati della subscription di un device
     */
    deviceSubscriptionGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
                throw new runtime.RequiredError('deviceId', 'Required parameter requestParameters.deviceId was null or undefined when calling deviceSubscriptionGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/private/subscription/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Restituisce i dati associati alla subscription di un device
     * Restituisce i dati della subscription di un device
     */
    deviceSubscriptionGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deviceSubscriptionGetRaw(requestParameters);
        });
    }
    /**
     * Aggiorna lo stato di una subscription di un device
     * Aggiorna una subscription
     */
    deviceSubscriptionPutRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
                throw new runtime.RequiredError('deviceId', 'Required parameter requestParameters.deviceId was null or undefined when calling deviceSubscriptionPut.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/private/subscription/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.PNSSubscriptionDataToJSON(requestParameters.pNSSubscriptionData),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PNSResponseSubscriptionFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna lo stato di una subscription di un device
     * Aggiorna una subscription
     */
    deviceSubscriptionPut(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deviceSubscriptionPutRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.DeviceSubscriptionApi = DeviceSubscriptionApi;
